/** Hersteller, deren Farben über das Sarlas-Händlerportal abgeglichen werden. */
export const SARLAS_HERSTELLER_SCHLUESSEL = ["sarlas-s-a-in-style"];
export function istSarlasHersteller(schluessel) {
    return SARLAS_HERSTELLER_SCHLUESSEL.includes(schluessel);
}
//# sourceMappingURL=sarlas.js.map